import { UserRole } from '#/common/types/userTypes';
import type { MenuItemProps } from './MenuItem';

export type GetMenuItemsParams = {
  role?: UserRole;
};

export type GetMenuItems = (params: GetMenuItemsParams) => MenuItemProps[];

export const rolesWithAccessToAdminMenu: UserRole[] = [UserRole.trane_admin];

const getMenuItems: GetMenuItems = (params: GetMenuItemsParams) => {
  const res = [
    {
      label: 'Dashboard',
      route: '/dashboard',
      icon: 'chart-pie-simple',
    },
    {
      label: 'Assets',
      route: '/assets',
      icon: 'cube',
    },
    {
      label: 'Asset Plans',
      route: '/asset-plans',
      icon: 'chart-mixed-up-circle-dollar',
      desktopOnly: true,
    },
    {
      label: 'Work Orders',
      route: '/work-orders',
      icon: 'wrench',
    },
    {
      label: 'Findings',
      route: '/findings',
      icon: 'flag',
    },
    {
      label: 'Expenses',
      route: '/expenses',
      icon: 'money-bills',
    },
    {
      label: 'Exceptions',
      route: '/alerts?filters=["state","anyof",["new","processed","resolved"]]',
      icon: 'octagon-exclamation',
      filled: false,
    },
  ] as MenuItemProps[];

  res.forEach((menuItem) => (menuItem.shouldShow = true));

  const adminMenuItem = {
    label: 'Admin',
    route: '/admin',
    icon: 'key',
    shouldShow: false,
  } as MenuItemProps;

  res.push(adminMenuItem);

  if (params?.role && rolesWithAccessToAdminMenu.includes(params?.role)) {
    adminMenuItem.shouldShow = true;
  }

  return res;
};

export default getMenuItems;
